import React, { ReactNode, useContext, useEffect, useState } from 'react';

import ReportsContext from '@totem/components/reports/ReportsContext';
import { AdditionalContext } from '@totem/components/ui_components/menus/mainMenu/additionalContext';
import { getMainMenuItems } from '@totem/components/ui_components/menus/mainMenu/mainMenu';
import MainMenuContext from '@totem/components/ui_components/menus/menuContext';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import ContractedServicesContext from '@totem/components/userContext/contractedServicesContext/contractedServicesContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

type Props = {
  children?: ReactNode;
};

const MenuContainer = ({ children }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const { reports } = useContext(ReportsContext);
  const { data } = useContext(ContractedServicesContext);

  const [mainMenu, setMainMenu] = useState<IBMenuItem[]>([]);

  useEffect(() => {
    const additionalContext: AdditionalContext = {
      reports,
    };

    const mainMenuItems = getMainMenuItems(
      userProfile,
      additionalContext,
      data,
    );
    setMainMenu(mainMenuItems);
  }, [userProfile, data]);

  return (
    <MainMenuContext.Provider
      value={{
        mainMenu,
      }}
    >
      {children}
    </MainMenuContext.Provider>
  );
};

export default MenuContainer;
